import React from "react";
import {Button, Checkbox, Form, Input, Select, Space} from "antd";
import {MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";
import {useFullVoc} from "../../hooks/voc.hook";
import {flkType, moType, operationTwoQuery, stepOption} from "../../stores/fixed/BuildInVocs";
import {makeSelectOption, PatientQuerySimpleEditor} from "./Parts/PatientQuerySimpleEditor";
import {RgSelect} from "../../utils/antdhelper/RgControls";


const tailLayout = {
    wrapperCol: { offset: 8, span: 16 },
};

const TargetAreaEditor =   () =>      <Form.List name={"area"}>
    {(fields, { add, remove }) => (
        <>
            {fields.map(field => (
                <Space key={field.key} align="baseline">
                    <Form.Item
                        {...field}
                        label="Мед.огр"
                        name={[field.name, 'medorg']}
                        fieldKey={[field.fieldKey, 'medorg']}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item>
                        <Select>
                            {moType.map(makeSelectOption)}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        {...field}
                        label="Населённый пункт"
                        name={[field.name, 'subarea']}
                        fieldKey={[field.fieldKey, 'subarea']}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        {...field}
                        label="Район"
                        name={[field.name, 'area']}
                        fieldKey={[field.fieldKey, 'area']}
                    >
                        <Input />
                    </Form.Item>

                    <MinusCircleOutlined onClick={() => remove(field.name)} />
                </Space>
            ))}
            <Form.Item>
                <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                    Добавить целевую терроторию
                </Button>
            </Form.Item>
        </>
    )}
</Form.List>


const FlkForm = ({}) => {
    const event = useFullVoc('eventtp').map(makeSelectOption)
    const [form] = Form.useForm();

    const onFinish = (values) => {
        console.log(values);
    }

    return (<div>
        <Form
            onFinish={onFinish}
        >
            <Form.Item label="Условие 1">
                <span className="ant-form-text">Признаки</span>
            </Form.Item>
            <PatientQuerySimpleEditor name={"cond1"}/>
            <Form.Item label={"Этап"} name={"step"}>
                <Select>
                    {stepOption.map(makeSelectOption)}
                </Select>
            </Form.Item>
            <Form.Item label="Условие 2">
                <span className="ant-form-text">Признаки</span>
            </Form.Item>
            <PatientQuerySimpleEditor/>
            <Form.Item label={"Связь"} name={"link"}>
                <Select>
                    {operationTwoQuery.map(makeSelectOption)}
                </Select>
            </Form.Item>
            <Form.Item label={"Этап"} name={"step"}>
                <Select>
                    {stepOption.map(makeSelectOption)}
                </Select>
            </Form.Item>
            <Form.Item label={"Тип"} name={"type"}>
                <Select>
                    {flkType.map(makeSelectOption)}
                </Select>
            </Form.Item>
            <Form.Item label={"Сообщение"} name={"msg"}>
                <Input></Input>
            </Form.Item>
            <Form.Item name={`p1`} valuePropName="">
                <Checkbox >Применимость: импорт</Checkbox>
            </Form.Item>
            <Form.Item name={`p2`} valuePropName="">
                <Checkbox >Применимость: API</Checkbox>
            </Form.Item>
            <Form.Item name={`p3`} valuePropName="">
                <Checkbox >Применимость: бесшовная интеграция</Checkbox>
            </Form.Item>
            <Form.Item name={`p4`} valuePropName="">
                <Checkbox >Применимость: ручной ввод</Checkbox>
            </Form.Item>
            <Form.Item {...tailLayout}>
                <Button type="primary" htmlType="submit">
                    Сохранить
                </Button>
            </Form.Item>
        </Form>
    </div>)}



export default FlkForm